import React, { PureComponent } from 'react';
import Logo from '../assets/logo_jf_pimi_sin_fondo.png';
import ImagenFooter from '../assets/logo-negro.png';
import '../App.css';
import Privacidad from './privacidad.jsx';
import Cookies from './cookies.jsx';

const SocialLinks = () => {
  return (
    <div className="footer__socials">
      <a
        href="https://www.facebook.com/profile.php?id=61556770483633"
        target="_blank"
        rel="noreferrer"
      >
        <i className="ri-facebook-fill"></i>
      </a>
      <a
        href="https://www.instagram.com/jfpimic/?igsh=MTNkOWpuYm53aXV5ZQ%3D%3D"
        target="_blank"
        rel="noreferrer"
      >
        <i className="ri-instagram-line"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/jf-pimi-agencia-de-marketing-digital-y-community-manager-1a5917282/"
        target="_blank"
        rel="noreferrer"
      >
        <i className="ri-linkedin-fill"></i>
      </a>
    </div>
  );
};

const linksEmpresa = [
  { url: '#inicio', texto: 'Inicio' },
  { url: '#objetivos', texto: 'Objetivos' },
  { url: '#planes', texto: 'Planes de pago' }
];

const linksContacto = [
  { url: 'tel:+34624395007', texto: '+34 624 39 50 07' },
  { url: 'mailto:jfpimic@gmail.com', texto: 'jfpimic@gmail.com' },
  { url: 'https://maps.app.goo.gl/J3WpdwKPknztzYW56', texto: 'Ubicación' }
];

const linksPoliticas = [
  { texto: 'Política de privacidad', componente: <Privacidad /> },
  { texto: 'Política de cookies', componente: <Cookies /> }
];

export default class Footer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mostrarBanner: false,
      contenidoBanner: null
    };
  }

  mostrarBanner = (contenido) => {
    this.setState({
      mostrarBanner: true,
      contenidoBanner: contenido
    });
  };

  ocultarBanner = () => {
    this.setState({
      mostrarBanner: false,
      contenidoBanner: null
    });
  };

  render() {
    return (
      <>
        <footer className="section__container footer__container">
          <span className="bg__blur"></span>
          <span className="bg__blur footer__blur"></span>

          <div className="footer__col footer__col--brand">
            <div className="footer__logo">
              <img src={Logo} alt="logo" />
            </div>
            <SocialLinks />
          </div>

          <div className="footer__col">
            <h4>Empresa</h4>
            {linksEmpresa.map((link, index) => (
              <a key={index} href={link.url}>
                {link.texto}
              </a>
            ))}
          </div>

          <div className="footer__col">
            <h4>Contacto</h4>
            {linksContacto.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target={link.url.startsWith('http') ? '_blank' : undefined}
                rel={link.url.startsWith('http') ? 'noreferrer' : undefined}
              >
                {link.texto}
              </a>
            ))}
          </div>

          <div className="footer__col">
            <h4>Políticas</h4>
            {linksPoliticas.map((link, index) => (
              <button
                key={index}
                type="button"
                onClick={() => this.mostrarBanner(link.componente)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginBottom: '1.2rem',
                  color: 'black',
                  textDecoration: 'none',
                  lineHeight: '1.4',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
              >
                {link.texto}
              </button>
            ))}
          </div>
        </footer>

        {this.state.mostrarBanner && (
          <div className="overlay" onClick={this.ocultarBanner}>
            <div className="banner" onClick={(e) => e.stopPropagation()}>
              <button className="cerrar" onClick={this.ocultarBanner}>
                Cerrar
              </button>
              {this.state.contenidoBanner}
            </div>
          </div>
        )}

        <div className="footer__bar">
          <p className="footer__copy">
            Copyright © {new Date().getFullYear()} JF PIMI
          </p>

          <a
            href="https://noos-solutions.es/"
            className="footer__logo-noos"
            target="_blank"
            rel="noreferrer"
          >
            <img src={ImagenFooter} alt="logo noos" />
          </a>
        </div>
      </>
    );
  }
}